import { render, staticRenderFns } from "./CourseBookContent.vue?vue&type=template&id=b373545c&scoped=true&"
import script from "./CourseBookContent.vue?vue&type=script&lang=js&"
export * from "./CourseBookContent.vue?vue&type=script&lang=js&"
import style0 from "./CourseBookContent.vue?vue&type=style&index=0&id=b373545c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b373545c",
  null
  
)

export default component.exports